import router from '@/router/index'
import $ from 'jquery'
import {
  Toast
} from 'vant'
export default {
  jump(url) {
    router.push(url)
  },
  back() {
    router.go(-1)
  },
  toast: (text, type = 'ok') => {
    let self = this
    switch (type) {
      case 'ok':
        Toast.success({
          forbidClick: true,
          message: text
        });
        break;
      case 'err':
        Toast.fail({
          forbidClick: true,
          message: text
        });
        break;
    }
  },
  load: (msg = '加载中...') => {
    Toast.loading({
      duration: 0,
      forbidClick: true,
      message: msg
    })
  },
  loadClose: () => {
    Toast.clear()
  },
  formatPrice(price) {
    return (price / 100).toFixed(2)
  },
  getScrollTop() {
    let scrollPos;
    if (window.pageYOffset) {
      scrollPos = window.pageYOffset;
    } else if (document.compatMode && document.compatMode != 'BackCompat') {
      scrollPos = document.documentElement.scrollTop;
    } else if (document.body) {
      scrollPos = document.body.scrollTop;
    }
    return scrollPos;
  },
  getScrollBot() {
    let scrollTop = $(window).scrollTop(); //滚动条距离顶部的高度
    let scrollHeight = $(document).height(); //当前页面的总高度
    let clientHeight = $(window).height(); //当前可视的页面高度
    let scrBot = scrollHeight - (scrollTop + clientHeight)
    return scrBot
  },
  countTime(endtime) {
    let d, h, m, s = null;
    let time = parseInt(endtime) - new Date().getTime();
    if (time <= 0) {
      return {
        d: 0,
        h: 0,
        m: 0,
        s: 0
      }
    } else {
      time = time / 1000
      d = Math.floor(time / 60 / 60 / 24)
      h = Math.floor((time / 60 / 60) % 24)
      m = Math.floor((time / 60) % 60)
      s = Math.floor(time % 60)
      h = h < 10 ? '0' + h : h
      m = m < 10 ? '0' + m : m
      s = s < 10 ? '0' + s : s
      return {
        d,
        h,
        m,
        s
      }
    }
  },
  stamToDate(time, type = '') {
    var unixtimestamp = new Date(parseInt(time));
    var year = 1900 + unixtimestamp.getYear();
    var month = "0" + (unixtimestamp.getMonth() + 1);
    var date = "0" + unixtimestamp.getDate();
    var hour = "0" + unixtimestamp.getHours();
    var minute = "0" + unixtimestamp.getMinutes();
    var second = "0" + unixtimestamp.getSeconds();
    if (type == 'short') {
      return year + "-" + month.substring(month.length - 2, month.length) + "-" + date.substring(date.length - 2, date.length)
    } else {
      return year + "-" + month.substring(month.length - 2, month.length) + "-" + date.substring(date.length - 2, date.length) +
        " " + hour.substring(hour.length - 2, hour.length) + ":" +
        minute.substring(minute.length - 2, minute.length) + ":" +
        second.substring(second.length - 2, second.length)
    }
  },
  dateToStam(time) {
    let dateTime = new Date(time.replace(/-/g, '/'))
    return dateTime.getTime()
  },
  normalShare(path = '', title = '', imgUrl = '', desc = '', success = '') {
    let npath = path
    if (path.indexOf("/") != -1) {
      npath = path.replace(/\//g, ".")
    }
    let g = window.g
    let stitle = g.title
    let sdesc = g.desc
    let simgUrl = g.imgUrl
    let slink = `${g.link}&router=${npath}#/${path}`
    if (title != '') {
      stitle = title
    }
    if (desc != '') {
      sdesc = desc
    }
    if (imgUrl != '') {
      simgUrl = imgUrl
    }
    if (success == '') {
      window.sharedata.success = function() {}
    } else {
      window.sharedata.success = success
    }
    window.sharedata.title = stitle
    window.sharedata.desc = sdesc
    window.sharedata.link = slink
    window.sharedata.imgUrl = simgUrl

  },
  back() {
    if (window.history.length <= 1) {
      router.push('/')
      return false
    } else {
      router.go(-1)
    }
  },
  /*
        函数，加法函数，用来得到精确的加法结果
        说明：javascript的加法结果会有误差，在两个浮点数相加的时候会比较明显。这个函数返回较为精确的加法结果。
        参数：arg1：第一个加数；arg2第二个加数；d要保留的小数位数（可以不传此参数，如果不传则不处理小数位数）
        调用：Calc.Add(arg1,arg2,d)
        返回值：两数相加的结果
        */
  Add(arg1, arg2) {
    arg1 = arg1.toString(), arg2 = arg2.toString();
    var arg1Arr = arg1.split("."),
      arg2Arr = arg2.split("."),
      d1 = arg1Arr.length == 2 ? arg1Arr[1] : "",
      d2 = arg2Arr.length == 2 ? arg2Arr[1] : "";
    var maxLen = Math.max(d1.length, d2.length);
    var m = Math.pow(10, maxLen);
    var result = Number(((arg1 * m + arg2 * m) / m).toFixed(maxLen));
    var d = arguments[2];
    return typeof d === "number" ? Number((result).toFixed(d)) : result;
  },
  /*
  函数：减法函数，用来得到精确的减法结果
  说明：函数返回较为精确的减法结果。
  参数：arg1：第一个加数；arg2第二个加数；d要保留的小数位数（可以不传此参数，如果不传则不处理小数位数
  调用：Calc.Sub(arg1,arg2)
  返回值：两数相减的结果
  */
  Sub(arg1, arg2) {
    return Calc.Add(arg1, -Number(arg2), arguments[2]);
  },
  /*
  函数：乘法函数，用来得到精确的乘法结果
  说明：函数返回较为精确的乘法结果。
  参数：arg1：第一个乘数；arg2第二个乘数；d要保留的小数位数（可以不传此参数，如果不传则不处理小数位数)
  调用：Calc.Mul(arg1,arg2)
  返回值：两数相乘的结果
  */
  Mul(arg1, arg2) {
    var r1 = arg1.toString(),
      r2 = arg2.toString(),
      m, resultVal, d = arguments[2];
    m = (r1.split(".")[1] ? r1.split(".")[1].length : 0) + (r2.split(".")[1] ? r2.split(".")[1].length : 0);
    resultVal = Number(r1.replace(".", "")) * Number(r2.replace(".", "")) / Math.pow(10, m);
    return typeof d !== "number" ? Number(resultVal) : Number(resultVal.toFixed(parseInt(d)));
  },
  /*
  函数：除法函数，用来得到精确的除法结果
  说明：函数返回较为精确的除法结果。
  参数：arg1：除数；arg2被除数；d要保留的小数位数（可以不传此参数，如果不传则不处理小数位数)
  调用：Calc.Div(arg1,arg2)
  返回值：arg1除于arg2的结果
  */
  Div(arg1, arg2) {
    var r1 = arg1.toString(),
      r2 = arg2.toString(),
      m, resultVal, d = arguments[2];
    m = (r2.split(".")[1] ? r2.split(".")[1].length : 0) - (r1.split(".")[1] ? r1.split(".")[1].length : 0);
    resultVal = Number(r1.replace(".", "")) / Number(r2.replace(".", "")) * Math.pow(10, m);
    return typeof d !== "number" ? Number(resultVal) : Number(resultVal.toFixed(parseInt(d)));
  },
  resizeImg(type = 1, w = '', h = '') {
    let windowW = $(window).width()
    switch (type) {
      case 1: //商品详情
        return `?imageView2/1/w/${windowW*2}/h/${windowW*2}`
        break;
      case 2: //店铺详情 、砍价
        return `?imageView2/1/w/${windowW*2}/h/${windowW}`
        break;
      case 3: //商品列表
        return `?imageView2/1/w/${windowW}/h/${windowW}`
        break;
      case 4: //商品缩略图
        return `?imageView2/1/w/100/h/100`
        break;
      default:
    }
  },
  formatDistance(dis) {
    if (dis > 1000) {
      dis = dis / 1000
      dis = dis.toFixed(1) + 'km'
    } else {
      dis = dis + 'm'
    }
    return dis
  },
  setStorage(key, value) {
    let jsonVal = JSON.stringify(value)
    sessionStorage.setItem(key, jsonVal)
  },
  getStorage(key) {
    let value = sessionStorage.getItem(key)
    if (typeof value == 'undefined') {
      return null
    } else {
      let obj = JSON.parse(value)
      return obj
    }
  },
  isInWeixin() {
    let ua = navigator.userAgent.toLowerCase()
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
      return true;
    } else {
      return false;
    }
  }
}
